(function () {
  if (window.TuyaRecentlyViewedInitialized) return;

  window.TuyaRecentlyViewedInitialized = true;

  const SECTION_SELECTOR = '[data-tuya-section="recently-viewed"]';
  const ITEM_SELECTOR = '.tuya-featured-products__item';
  const TRACK_SELECTOR = '.tuya-featured-products__track';
  const PREV_SELECTOR = '.tuya-carousel-nav--prev';
  const NEXT_SELECTOR = '.tuya-carousel-nav--next';
  const STORAGE_KEY = 'viewedProducts';

  const sectionCleanups = new WeakMap();

  function findSection(target) {
    if (!target) return null;
    return target.matches(SECTION_SELECTOR)
      ? target
      : target.querySelector(SECTION_SELECTOR);
  }

  function getTrackGap(track) {
    return parseFloat(window.getComputedStyle(track).gap) || 0;
  }

  function getItems(track) {
    return Array.from(track.querySelectorAll(ITEM_SELECTOR));
  }

  function getScrollStep(track) {
    const items = getItems(track);
    const firstItem = items.find((item) => !item.hidden);
    if (!firstItem) return track.clientWidth;
    return firstItem.getBoundingClientRect().width + getTrackGap(track);
  }

  function initCarousel(section) {
    if (section.dataset.tuyaDisplayMode !== 'carousel') return null;

    const track = section.querySelector(TRACK_SELECTOR);
    const prevBtn = section.querySelector(PREV_SELECTOR);
    const nextBtn = section.querySelector(NEXT_SELECTOR);

    if (!track || !prevBtn || !nextBtn) return null;

    function updateNavButtons() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
    }

    function handlePrevClick() {
      track.scrollBy({
        left: -getScrollStep(track),
        behavior: 'smooth',
      });
    }

    function handleNextClick() {
      track.scrollBy({
        left: getScrollStep(track),
        behavior: 'smooth',
      });
    }

    function handleTrackScroll() {
      updateNavButtons();
    }

    prevBtn.addEventListener('click', handlePrevClick);
    nextBtn.addEventListener('click', handleNextClick);
    track.addEventListener('scroll', handleTrackScroll, { passive: true });
    window.addEventListener('resize', updateNavButtons);
    window.setTimeout(updateNavButtons, 100);

    return function cleanupCarousel() {
      prevBtn.removeEventListener('click', handlePrevClick);
      nextBtn.removeEventListener('click', handleNextClick);
      track.removeEventListener('scroll', handleTrackScroll);
      window.removeEventListener('resize', updateNavButtons);
    };
  }

  function handleEmptySection(section) {
    if (window.Shopify && window.Shopify.designMode) {
      section.style.display = 'none';
    } else {
      section.remove();
    }
  }

  function loadRecentlyViewed(section) {
    const searchUrl = section.dataset.searchUrl;
    const sectionId = section.dataset.tuyaSectionId;
    if (!searchUrl || !sectionId) return;

    let viewedProducts = [];
    try {
      viewedProducts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      console.error('Failed to parse viewedProducts from localStorage', e);
    }

    const currentProductId = section.dataset.currentProductId;
    if (currentProductId) {
      viewedProducts = viewedProducts.filter((id) => id !== currentProductId);
    }

    const limit = parseInt(section.dataset.tuyaLimit, 10) || 4;
    viewedProducts = viewedProducts.slice(0, limit);

    if (viewedProducts.length === 0) {
      handleEmptySection(section);
      return;
    }

    const query = viewedProducts.map((id) => `id:${id}`).join(' OR ');
    const url = `${searchUrl}?resources[type]=product&q=${encodeURIComponent(query)}&section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const renderedSection = doc.querySelector(SECTION_SELECTOR);

        if (renderedSection && renderedSection.innerHTML.trim().length > 0) {
          const hasProducts = renderedSection.querySelector(ITEM_SELECTOR);
          if (hasProducts) {
            const track = renderedSection.querySelector(TRACK_SELECTOR);
            if (track) {
              const items = Array.from(track.querySelectorAll(ITEM_SELECTOR));
              items.sort((a, b) => {
                const idA = a.dataset.productId;
                const idB = b.dataset.productId;
                return viewedProducts.indexOf(idA) - viewedProducts.indexOf(idB);
              });
              track.innerHTML = '';
              items.forEach((item) => track.appendChild(item));
            }

            section.innerHTML = renderedSection.innerHTML;
            section.classList.add('is-loaded');

            const items = getItems(section);
            items.forEach((item, index) => {
              item.style.setProperty('--reveal-delay', `${index * 60}ms`);
              item.classList.add('is-revealing');
              setTimeout(() => {
                item.classList.remove('is-revealing');
                item.style.removeProperty('--reveal-delay');
              }, 500 + index * 60);
            });

            const cleanupCarousel = initCarousel(section);
            if (cleanupCarousel) {
              sectionCleanups.set(section, cleanupCarousel);
            }
          } else {
            handleEmptySection(section);
          }
        } else {
          handleEmptySection(section);
        }
      })
      .catch((err) => {
        console.error('Failed to load recently viewed products:', err);
        handleEmptySection(section);
      });
  }

  function initSection(section) {
    if (!section) return;

    const cleanup = sectionCleanups.get(section);
    if (cleanup) {
      cleanup();
      sectionCleanups.delete(section);
    }

    loadRecentlyViewed(section);
  }

  function initAllSections() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSection(findSection(event.target));
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = findSection(event.target);
    if (section) {
      const cleanup = sectionCleanups.get(section);
      if (cleanup) {
        cleanup();
        sectionCleanups.delete(section);
      }
    }
  });
})();
